/**
 * Semantic linter rules for AudioStreamPlayer2D. linterParser.ts validates the format during strict
 * parsing. These rules need the full scene.
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { resourceSlotIsEmpty } from '../../../linter/resourceChecker.js';
import { isDrivenByAnimationAudioTrack } from '../sharedLinterChecks.js';
import { boolSlotValue } from '../../../godot/variant/variantBool.js';
import { armEmits, groundedArm, reportArm } from '../../../linter/ruleArms.js';
const arms = {
    autoplayWithoutStream: groundedArm('audiostreamplayer2d-autoplay-without-stream', {
        kind: 'engine-inert',
        at: 'audio_stream_player_internal.cpp:139',
        unused: 'play_basic returns an empty playback, so autoplay produces no sound',
    }),
};
/**
 * Validate AudioStreamPlayer2D semantic rules
 */
function checkAudioStreamPlayer2D(context) {
    const diagnostics = [];
    const { node, scene } = context;
    const rawProps = node.rawProperties;
    // A stream can also arrive through an AnimationPlayer audio track that
    // targets this node (animation_mixer.cpp:891-898 builds its own polyphonic
    // playback and never reads the node's `stream`), so a node driven that way
    // is not silent despite having no `stream` of its own.
    const streamEmpty = resourceSlotIsEmpty(rawProps.stream);
    const drivenByAnimation = streamEmpty && isDrivenByAnimationAudioTrack(scene, node);
    // A player with no `stream` at all gets no diagnostic: that is the serialised
    // default, audio_stream_player_2d.cpp defines no configuration warning, and a
    // script may assign one at runtime.
    // Autoplay enabled but no stream set.
    if (boolSlotValue(rawProps.autoplay) === true && streamEmpty && !drivenByAnimation) {
        reportArm(diagnostics, arms.autoplayWithoutStream, node, `Property 'autoplay' is enabled but no 'stream' is set. Audio will not play automatically.`);
    }
    return diagnostics;
}
/**
 * AudioStreamPlayer2D semantic validation rule
 */
const audioStreamPlayer2DValidationRule = {
    meta: {
        name: 'valid-audiostreamplayer2d-properties',
        description: 'Validates AudioStreamPlayer2D property values and logical consistency',
        category: 'validation',
        applicableNodeTypes: ['AudioStreamPlayer2D'],
        emits: armEmits(arms),
    },
    check: checkAudioStreamPlayer2D,
};
ruleRegistry.register(audioStreamPlayer2DValidationRule);
// Export for testing
//# sourceMappingURL=linter.js.map